import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.scss';

export default function ContentWrapper(props) {
	const { transparent, shadow, border, last, children, manual, fullHeight } = props;

	return (
		<>
			<div className={classNames({ content: !manual, 'content--border': border, 'content--transparent': transparent, 'content--full-height': fullHeight, 'content--shadow': shadow, 'content--last': last })}>{children}</div>
		</>
	);
}

ContentWrapper.propTypes = {
	transparent: PropTypes.bool,
	shadow: PropTypes.bool,
	last: PropTypes.bool,
	fullHeight: PropTypes.bool
};

ContentWrapper.defaultProps = {
	transparent: false,
	shadow: false,
	last: false,
	fullHeight: false
};
